import { useQuery } from "react-query";
import { peerGroupQueryKeys } from "queries/constants";
import { QueryOptions } from "queries/queries";
import { useToast } from "components/common/ui/toast/useToast";
import { fetchPeerGroupDetails } from "api/PeerGroupApi";

export const usePeerGroupDetail = (
  peergroupId: string,
  options?: QueryOptions
) => {
  const { addErrorToast } = useToast();
  return useQuery(
    peerGroupQueryKeys.detail(peergroupId),
    () => fetchPeerGroupDetails(peergroupId),
    {
      onError: (e) =>
        addErrorToast(e, "Unable to load peer group details", {
          id: peerGroupQueryKeys.detail(peergroupId).join("::"),
        }),
      staleTime: 60 * 1000,
      ...options,
    }
  );
};
